import styled from 'styled-components';

export const Container = styled.div`
  section{
    width: 75vh;
    @media only screen and (max-width: 768px) {
      width: 72vh;
    }
    @media only screen and (max-width: 720px) {
      width: 65vh;
    }
    @media only screen and (max-width: 420px) {
      width: 63vh;
    }
  }

  form {
    width: 100%;

    .buttonsContainer {
      display: flex;
      justify-content: flex-end;
    }

    input {
      height: 40px;
    }
  }
  }
`;
